module.exports = __webpack_public_path__ + "static/case_img3-bfaf9f64f76f99a4648b04c6187c56aa.png";